import API from "@/lib/API";

export const leadService = {
  getLeads: async (params = {}) => {
    return await API.get('/verve-leads', { params });
  },

  getSalesHeadLeads: async (params = {}) => {
    return await API.get('/verve-leads/sales-head', { params });
  },

  create: async (data) => {
    return await API.post('/verve-leads', data);
  },

  update: async (id, data) => {
    // If data contains files, use FormData
    const hasFiles = (data.files && Array.isArray(data.files) && data.files.some(f => f instanceof File)) ||
      (data.quotationFile && Array.isArray(data.quotationFile) && data.quotationFile.some(f => f instanceof File));

    if (hasFiles) {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (key === 'files' || key === 'quotationFile') {
          const fileList = data[key];
          if (Array.isArray(fileList)) {
            fileList.forEach(file => {
              if (file instanceof File) {
                formData.append(key, file);
              }
            });
          }
        } else {
          formData.append(key, data[key]);
        }
      });
      return await API.patch(`/verve-leads/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
    return await API.patch(`/verve-leads/${id}`, data);
  },



  toggleDisable: async (id, isDisabled) => {
    return await API.patch(`/verve-leads/${id}`, { isDisabled });
  },

  deleteLead: async (id) => {
    return await API.delete(`/verve-leads/${id}`);
  },

  getActivities: async (leadId) => {
    return await API.get(`/verve-leads/${leadId}/activities`);
  },

  addActivity: async (leadId, data) => {
    return await API.post(`/verve-leads/${leadId}/activities`, data);
  },

  getToday: async (params = {}) => {
    return await API.get('/verve-leads', { params: { ...params, date: 'today' } });
  },

  getThisWeek: async (params = {}) => {
    return await API.get('/verve-leads', { params: { ...params, date: 'this_week' } });
  },

  getThisMonth: async (params = {}) => {
    return await API.get('/verve-leads', { params: { ...params, date: 'this_month' } });
  },

  getThisYear: async (params = {}) => {
    return await API.get('/verve-leads', { params: { ...params, date: 'this_year' } });
  },

  getCustomRange: async (fromDate, toDate, params = {}) => {
    return await API.get('/verve-leads', { params: { ...params, fromDate, toDate } });
  },

  getActivityStats: async (params = {}) => {
    const response = await API.get('/verve-leads/stats/activity', { params });
    return response.data?.data || response.data || response;
  }
};
